import {
  BehaviorAuthorizationType,
  useHasBehaviorAuthorization,
} from './useHasBehaviorAuthorization';

export function useCanEditDispositiveProvisions(): boolean {
  return useHasBehaviorAuthorization(
    BehaviorAuthorizationType.CAN_EDIT_DISPOSITIVE_PROVISIONS,
    { returnFalseOnMissingUser: true }
  );
}
